import React from 'react';
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActionArea from "@material-ui/core/CardActionArea";
import {NavLink} from "react-router-dom";
import Box from "@material-ui/core/Box";
import {createMuiTheme, Link, MuiThemeProvider} from "@material-ui/core";
import {green, lightBlue} from "@material-ui/core/colors";
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ForgotAccountContainer from "../common/ForgotAccount/ForgotAccountContainer";


const SignUp = (props) => {
    const iconsColor = createMuiTheme({
        palette: {
            primary: green,
            secondary: lightBlue
        }
    });



    return (
        <div className="main ps-0">
            <div className="container-fluid">
                <div className="sign-up sign-up__first-page mb-4">
                    <Typography variant={"h4"} className={"mb-1"}>Регистрация Отельера</Typography>
                    <Box className="alert alert-warning mb-4">
                        Если вы отельер и хотите добавить свою гостиницу или квартиру на сайт - зарегистрируйтесь ниже
                    </Box>

                    {/*<Typography variant={"subtitle"} className={"mb-4"}>Если вы отельер и хотите добавить свою гостиницу или квартиру на сайт - зарегистрируйтесь ниже</Typography>*/}
                    <div className="row g-1 mb-3">
                        <div className="col-sm-6">
                            <Card className="h-100">
                                <CardActionArea className="h-100" component={NavLink} to="/lk/registration/phone">
                                    <CardContent>
                                        <Box className="text-center">
                                            <MuiThemeProvider theme={iconsColor}>
                                                <PhoneEnabledIcon fontSize="large" color="primary"></PhoneEnabledIcon>
                                            </MuiThemeProvider>
                                        </Box>
                                        <Typography component="h6" variant="h6">
                                            По номеру телефона
                                        </Typography>
                                        <Typography variant="body2" component="p">
                                            Необходимо будет подтвердить номер телефона через мессенджер
                                        </Typography>

                                    </CardContent>
                                </CardActionArea>
                            </Card>

                        </div>
                        <div className="col-sm-6">
                            <Card className="h-100">
                                <CardActionArea className="h-100" component={NavLink} to="/lk/registration/mail">
                                    <CardContent>
                                        <Box className="text-center">
                                            <MuiThemeProvider theme={iconsColor}>
                                                <AlternateEmailIcon fontSize="large"
                                                                    color="secondary"></AlternateEmailIcon>
                                            </MuiThemeProvider>
                                        </Box>
                                        <Typography component="h6" variant="h6">
                                            По
                                            электронной
                                            почте
                                        </Typography>

                                        <Typography variant="body2" component="p">
                                            Необходимо будет подтвердить электронную почту
                                        </Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </div>

                    </div>
                    <div className="row text-center justify-content-center">
                        <div className='col-12 mb-3  mt-2'>
                            У Вас уже есть аккаунт? <Link component={NavLink} to="/lk/login">Войти</Link>
                        </div>
                    </div>

                </div>
                <ForgotAccountContainer/>
            </div>
        </div>
    );
}


export default SignUp;
